import React, {FC} from 'react'
import {PageTitle} from '@/_metronic/layout/core'
import {TableWrapper} from '@/components/table/TableWrapper'
import {getActivity} from '../core/_requests'
import {getColumns} from './columns/_columns'
import {ButtonProps, ModalWrapperProps} from '@/components/table/core/_types'
import {Modal} from '@/components/table/modal/Modal'
import BreadcrumbsBuilder from '@/components/layout/BreadcrumbsBuilder'
import {Overview} from './components/Overview'
import {useIntl} from 'react-intl'

const ListWrapper = () => {
  const intl = useIntl()

  const Breadcrumbs = BreadcrumbsBuilder([{
    title: `${intl.formatMessage({id: 'CORE.HOME.BREADCRUMBS'})}`,
    path: '/'
  }, {
    title: `${intl.formatMessage({id: 'CORE.USERS.LIST.BREADCRUMBS'})}`,
      path: '/app/users/list',
  }])

  const ModalWrapper: FC<ModalWrapperProps> = ({itemForUpdate, action}) => {
    return (
      <>
        {itemForUpdate !== undefined && action === 'details' && (
          <Modal title={`${intl.formatMessage({id: 'CORE.USERS.ACTIVITY.MODAL_REQUEST_DETAILS.TITLE'})}`} maxWidth={800}>
            <Overview />
          </Modal>
        )}
      </>
    )
  }

  return (
    <>
      <PageTitle breadcrumbs={Breadcrumbs}>
        {intl.formatMessage({id: 'CORE.USERS.ACTIVITY.PAGE_TITLE'})}
      </PageTitle>
      <TableWrapper
        dataProvider={getActivity}
        cols={getColumns(intl)}
        queryId="P2C_CUSTOMER_ACTIVITY_LIST"
        lookup={{placeholder: `${intl.formatMessage({id: 'CORE.USERS.ACTIVITY.LOOKUP_PLACEHOLDER'})}`}}
        modals={ModalWrapper}
      />
    </>
  )
}

export default ListWrapper
